module.exports = __webpack_public_path__ + "static/media/slide2.6fecc185.jpg";